/* stellar-shop.js: the cabinet and the collection pages.
   The constellation in every empty media box, the pour film on hover, and the refine card: one question per view,
   each answer fetches the collection again through Shopify's storefront filters and swaps the bottles in place.
   Sort and "show more" work the same way. Events go through the site data layer (stellar-data.js) when it is present. */
(function () {
  'use strict';
  function trk(event, data, opts) { if (window.stellar && window.stellar.track) return window.stellar.track(event, data, opts); }

  /* the constellation: a star field that breathes, in every box without a film or an image */
  function stars(c) {
    if (c.dataset.sxsOn) return; c.dataset.sxsOn = '1';
    var ctx = c.getContext('2d'), list = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), raf;
    function frame() {
      ctx.clearRect(0, 0, w, h);
      var g = ctx.createRadialGradient(w * .3, h * .2, 0, w * .3, h * .2, w * .8); g.addColorStop(0, 'rgba(214,200,143,.10)'); g.addColorStop(1, 'rgba(11,11,12,0)'); ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      list.forEach(function (s) { s.a += s.d; if (s.a > 1 || s.a < .15) s.d *= -1; ctx.globalAlpha = Math.max(.15, Math.min(1, s.a)); ctx.fillStyle = '#E4D8A8'; ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2); ctx.fill(); });
      ctx.globalAlpha = 1;
    }
    function size() {
      w = c.width = Math.max(1, c.offsetWidth * dpr); h = c.height = Math.max(1, c.offsetHeight * dpr); list = [];
      for (var i = 0; i < Math.round(w * h / (9000 * dpr)); i++) list.push({ x: Math.random() * w, y: Math.random() * h, r: (Math.random() * 1.2 + .3) * dpr, a: Math.random(), d: (Math.random() * .02 + .004) * (Math.random() < .5 ? 1 : -1) });
      frame();
    }
    function draw() { frame(); raf = requestAnimationFrame(draw); }
    size(); draw();
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(c); else window.addEventListener('resize', size);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { if (!raf) draw(); } else { cancelAnimationFrame(raf); raf = 0; } }); }).observe(c);
  }

  /* the pour film plays on hover, and stops when you leave */
  function hover(root) {
    if (root.dataset.sxsOn) return; root.dataset.sxsOn = '1';
    var v = root.querySelector('video[data-hover-film]'); if (!v) return;
    var card = root.closest('.sxs-card') || root;
    card.addEventListener('mouseenter', function () { try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {} });
    card.addEventListener('mouseleave', function () { try { v.pause(); } catch (e) {} });
  }

  /* the refine card and the bottles */
  function collection(root) {
    // Retired price filters must not silently restrict bookmarked collection links.
    var current = new URL(location.href);
    if (current.searchParams.has('filter.v.price.gte') || current.searchParams.has('filter.v.price.lte')) {
      current.searchParams.delete('filter.v.price.gte'); current.searchParams.delete('filter.v.price.lte'); current.searchParams.delete('page');
      location.replace(current.toString()); return;
    }
    if (root.dataset.sxsOn) return; root.dataset.sxsOn = '1';
    var id = root.getAttribute('data-section'), qi = parseInt(root.getAttribute('data-open') || '0', 10) || 0;
    function el(sel) { return root.querySelector(sel); }
    function qs() { return Array.prototype.slice.call(root.querySelectorAll('[data-refine] .fq')); }
    function showQ(n) {
      var list = qs(); if (!list.length) return;
      qi = Math.max(0, Math.min(n, list.length - 1)); list.forEach(function (q, k) { q.hidden = k !== qi; });
      var back = el('[data-fback]'), bar = el('[data-refine] .bar i');
      if (back) back.hidden = qi === 0; if (bar) bar.style.width = Math.round(((qi + 1) / list.length) * 100) + '%';
      root.setAttribute('data-open', qi);
    }
    function load(url, opts) {
      opts = opts || {};
      var grid = el('[data-grid]'); if (grid) grid.classList.add('busy');
      var u = new URL(url, location.href); u.searchParams.set('section_id', id);
      return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), fresh = doc.querySelector('[data-coll-inner]'), mine = el('[data-coll-inner]');
        if (!fresh || !mine) { location.href = url; return; }
        if (opts.append) {
          var g = el('[data-grid]'), fg = fresh.querySelector('[data-grid]');
          if (g && fg) Array.prototype.slice.call(fg.children).forEach(function (c) { g.appendChild(c); });
          var more = el('[data-more-wrap]'), fmore = fresh.querySelector('[data-more-wrap]'); if (more && fmore) more.replaceWith(fmore);
          var cnt = el('[data-count-line]'), fcnt = fresh.querySelector('[data-count-line]'); if (cnt && fcnt) cnt.textContent = fcnt.textContent;
        } else {
          mine.replaceWith(fresh);
          var clean = new URL(url, location.href); clean.searchParams.delete('section_id');
          try { history.pushState({}, '', clean.toString()); } catch (e) {}
        }
        wire(); showQ(opts.next ? qi + 1 : qi);
        var g2 = el('[data-grid]'); if (g2) g2.classList.remove('busy');
      }).catch(function () { location.href = url; });
    }
    function wire() {
      root.querySelectorAll('[data-stars]').forEach(stars);
      root.querySelectorAll('[data-hover-root]').forEach(hover);
    }
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-refine] input[type=radio][data-url]')) {
        trk('filter_picked', { question: t.name, value: t.value || 'any' }, { el: t });
        load(t.getAttribute('data-url'), { next: true }); return;
      }
      if (t.matches('[data-refine] input[data-price]')) {
        var pu = new URL(location.href), band = (t.getAttribute('data-price') || '').split('-');
        pu.searchParams.delete('filter.v.price.gte'); pu.searchParams.delete('filter.v.price.lte'); pu.searchParams.delete('page');
        if (band[0]) pu.searchParams.set('filter.v.price.gte', band[0]); if (band[1]) pu.searchParams.set('filter.v.price.lte', band[1]);
        trk('filter_picked', { question: 'price', value: t.getAttribute('data-price') || 'any' }, { el: t });
        load(pu.toString(), { next: true }); return;
      }
      if (t.matches('[data-refine] input[name=sort_by]')) { var u = new URL(location.href); u.searchParams.set('sort_by', t.value); u.searchParams.delete('page'); trk('sort_changed', { sort: t.value }, { el: t }); load(u.toString()); return; }
      if (t.matches('[data-refine] input[data-stock-url]')) { load(t.getAttribute('data-stock-url')); return; }
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fback]'); if (b) { showQ(qi - 1); return; }
      var ch = e.target.closest('[data-change]'); if (ch) { e.preventDefault(); showQ(parseInt(ch.getAttribute('data-change'), 10) || 0); return; }
      var rs = e.target.closest('[data-reset]'); if (rs) { e.preventDefault(); qi = 0; load(rs.getAttribute('href')); return; }
      var more = e.target.closest('[data-more]'); if (more) { e.preventDefault(); trk('show_more', {}, { el: more }); load(more.getAttribute('href'), { append: true }); return; }
    });
    wire(); showQ(qi);
  }

  function init(root) {
    root.querySelectorAll('[data-stars]').forEach(stars);
    root.querySelectorAll('[data-hover-root]').forEach(hover);
    if (root.matches('[data-collection]')) collection(root); else root.querySelectorAll('[data-collection]').forEach(collection);
  }
  function boot() { document.querySelectorAll('[data-sxs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-sxs]').forEach(init); });
})();
